import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CourseModel} from '@app/@core/domain/course.model';
import Course = CourseModel.Course;
import {objectField, ObjectField} from '@shared/components/model-viewer.component';
import {sm} from '@shared/components/easy-table.component';

interface Period {
    from: string;
    to: string;
    autoHotdeal: boolean;
}

interface CartSettingView {
    require: string;
    coursePrice: string;
    golfdiggPrice: string;
}

@Component({
    selector: 'app-course-setting-view',
    templateUrl: './course-setting-view.component.html',
    styles: [
      `
        .custom-card-body-padding ::ng-deep .p-card-body {
          padding-top: 0 !important;
        }
      `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseSettingViewComponent implements OnInit, OnChanges {
    @Input() course: Course;

    period: Period;
    cartSettingView: CartSettingView;

    constructor() {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.course) {
            const {cart} = this.course;
            this.cartSettingView = {
                require: cart.require ? 'Require' : (cart.maxRequire ? 'Max Require' : '-'),
                coursePrice: `${cart.priceOriginal}`,
                golfdiggPrice: `${cart.priceSale} (${cart.priceBase})`
            };

            const {bookingPeriod} = this.course;
            this.period = {
                from: '',
                to: `${bookingPeriod.max} Days`,
                autoHotdeal: this.course.autoHotDeal
            };

            if (bookingPeriod.min === 0){
                this.period .from = 'Same Day';
            }else if (bookingPeriod.min === 1){
                this.period .from = `1 Day before ${bookingPeriod.endTime}`;
            }else {
                this.period .from = `${bookingPeriod.min} Days`;
            }
        }
    }

}
